'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var bytes = require('../bytes.js');

var name = 'raw';
var code = 85;

var encode = function encode(node) {
  return bytes.coerce(node);
};

var decode = function decode(data) {
  return bytes.coerce(data);
};

exports.code = code;
exports.decode = decode;
exports.encode = encode;
exports.name = name;